<template>
    <div>
        <div class="inner-header">
            <nav class="navbar fixed-top animate__animated animate__slideInRight">
                <a @click="$router.go(-1)" class="back-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                        <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                            <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none"
                                stroke="#000" stroke-width="2" />
                            <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                        </g>
                    </svg>
                </a>
                <a href="javascript:void(0);" class="center-header" v-if="$route.params.callType=='todays_calls'">Today's Call</a>
                <a href="javascript:void(0);" class="center-header" v-if="$route.params.callType=='backlog_calls'">Backlog Call</a>
            </nav>
        </div>
        <div class="inner-page animate__animated animate__slideInRight">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                   <div class="search-holder mt-30 search-holder-list">
                      <div class="input-group">
                        <!-- <input type="text" class="form-control rounded-right" placeholder="Search Enquiry" /> -->
                        <input type="text" :placeholder="$route.params.page=='brokers' ? 'Search by title' : 'Search by name, enquiryno, email, phoneNo or enquiry'"
                          @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control"
                          @keyup.enter="FilterData" />
                          <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001"
                            style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14"
                            class="close r-70">
                            <g>
                              <g>
                                <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                                L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                                c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                                l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                                L284.286,256.002z" />
                              </g>
                            </g>
                          </svg>
                          <div class="input-group-append align-fix" id="button-addon4">
                              <!-- <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">Go</button> -->
                                <button class="btn btn-search" :disabled="!Filter" @click="FilterData" type="button">
                                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451"
                                    style="enable-background: new 0 0 451 451" xml:space="preserve">
                                    <g>
                                      <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                            s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                            C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                            s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                    </g>
                                  </svg>
                              </button>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <span class="result-Text1">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                    </div>
                  </div>
                  </div>
                    <!-- Enquiry Card -->
                    <div class="col-12">
                        <div class="card enquiry-card m-inner-height">
                            <b-list-group class="list-group-flush">
                            <template v-if="$route.params.page!=='brokers'">
                              <b-list-group-item :to="{ name: 'Details', params: {  id: item.id }}" v-for ="item in GetTodaysEnquiriesList" :key="item.id">
                                <div class="row">
                                  <div class="col-6 pr-1">
                                    <template v-if="$route.params.page=='brokers'">
                                      <span class="name ellipses">{{item.name}} - {{item.firm_name}}</span>
                                      <span class="project-name ellipses">{{item.locality_name}}</span>
                                    </template>
                                    <template v-else>
                                      <span class="name ellipses">{{item.full_name}}</span>
                                      <span class="project-name ellipses">{{item.enquiry}}</span>
                                    </template>
                                  </div>
                                  <div class="col-6 pl-1 text-right">
                                      <span class="label label-tag">{{item.status}}</span>
                                      <div class="d-block" v-if="$route.params.page!=='brokers'">
                                        <img src="@/assets/date.svg" alt="" class="date-icon mr-1">
                                        <span class="project-name">{{item.ncd}}</span>
                                      </div>
                                  </div>
                                </div>
                              </b-list-group-item>
                            </template>
                            <template v-if="$route.params.page=='brokers'">
                              <b-list-group-item :to="{ name: 'CPBrokerDetails', params: {  brokerid: item.id }}" v-for ="item in GetTodaysEnquiriesList" :key="item.id">
                                <div class="row">
                                  <div class="col-6 pr-1">
                                    <template v-if="$route.params.page=='brokers'">
                                      <span class="name ellipses">{{item.name}} - {{item.firm_name}}</span>
                                      <span class="project-name ellipses">{{item.locality_name}}</span>
                                    </template>
                                    <template v-else>
                                      <span class="name ellipses">{{item.full_name}}</span>
                                      <span class="project-name ellipses">{{item.enquiry}}</span>
                                    </template>
                                  </div>
                                  <div class="col-6 pl-1 text-right">
                                      <span class="label label-tag">{{item.status}}</span>
                                      <div class="d-block" v-if="$route.params.page!=='brokers'">
                                        <img src="@/assets/date.svg" alt="" class="date-icon mr-1">
                                        <span class="project-name">{{item.ncd}}</span>
                                      </div>
                                  </div>
                                </div>
                              </b-list-group-item>
                            </template>
                            </b-list-group>
                        </div>
                        <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage"
                          :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'"
                          :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'"
                          :page-class="'page-item'" :page-link-class="'page-link'">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { paramsFromQuery } from "@/assets/scripts/utility.js";
export default {
  name: "Today",
  data() {
    return {
      GetTodaysEnquiriesList: [],
      Filter: this.$route.query.search_query,
      total: 0,
      perPage: 0,
    }
  },
  computed: {
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    }
  },
  created () {
    this.FetchTodaysEnquiriesList()
  },
  watch: {
    $route(to, from) {
      this.FetchTodaysEnquiriesList();
    },
  },
  methods: {
    FetchTodaysEnquiriesList() {
      let queryP = {}
      let params = JSON.parse(localStorage.getItem("urlParams"));
      paramsFromQuery(queryP, this.$route.query);
      console.log(params,"params")
      if(params?.is_advanced_search) {
        queryP = {...queryP, ...params}
      }
      this.$axios.get(`${this.$route.params.page}/${this.$route.params.callType}`, { params: queryP }).then((res) => {
        this.GetTodaysEnquiriesList = res.data[this.$route.params.callType];
        this.perPage = res.data.per_page;
        this.total = res.data.total_count;
      });
    },
    goToPage(pageNo) {
      let newQ = {
        ...this.$route.query,
        pageNo
      };
      this.$router.replace({
        query: newQ
      });
    },
    resetFilter() {
      let rQ = this.$route.query;
      this.Filter = "";
      if (rQ.search_query) {
        let {
          search_query,
          ...newQ
        } = rQ;
        this.$router.replace({
          query: newQ
        });
      }
    },
    FilterData() {
      if (this.Filter) {
        let newQ = {
          ...this.$route.query,
          search_query: this.Filter
        };
        this.$router.replace({
          query: newQ
        });
      }
    }
  }
}
</script>
<style>
.pagination {
    margin-top: 40px;
    padding-bottom: 100px;
}
</style>